import webservice from './webservice';

export default async function postTerrapediaThemes(depto) {
  const url = `${webservice}/postTerrapediaThemes`;

  let response = {};

  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('TMBtoken')}`,
    },
    body: JSON.stringify({
      Action: 'CONSULTAR',
      Department: depto,
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
